import Joi from "joi";
import { VAR_LIMIT } from "../config/constant";

let minDate = new Date();
minDate = minDate.setFullYear(minDate.getFullYear() - VAR_LIMIT.age.max);

export const createPatientValidator = (data) => {
  const schema = Joi.object({
    name: Joi.string().required().messages({
      "string.empty": `"nama" tidak boleh kosong`,
    }),
    isMale: Joi.boolean().required(),
    dateOfBirth: Joi.date().required().min(minDate).max(Date.now()).messages({
      "any.required": `"Tanggal lahir" tidak boleh kosong`,
      "date.base": "Format tanggal tidak valid",
      "date.min": "Tanggal lahir tidak valid",
      "date.max": "Tanggal lahir tidak valid",
    }),
    weight: Joi.number()
      .min(VAR_LIMIT.weight.min)
      .max(VAR_LIMIT.weight.max)
      .required()
      .messages({
        "any.required": `"Berat badan" tidak boleh kosong`,
        "number.max": `"Berat badan" tidak valid`,
        "number.min": `"Berat badan" tidak valid`,
      }),
    height: Joi.number()
      .min(VAR_LIMIT.height.min)
      .max(VAR_LIMIT.height.max)
      .required()
      .messages({
        "any.required": `"Tinggi badan" tidak boleh kosong`,
        "number.max": `"Tinggi badan" tidak valid`,
        "number.min": `"Tinggi badan" tidak valid`,
      }),
  });
  console.log(data);
  return schema.validate(data);
};

export const updatePatientValidator = (data) => {
  const schema = Joi.object({
    dateOfBirth: Joi.date().min(minDate).max(Date.now()).allow(null).messages({
      "date.base": "Format tanggal tidak valid",
      "date.min": "Tanggal lahir tidak valid",
      "date.max": "Tanggal lahir tidak valid",
    }),
    weight: Joi.number()
      .min(VAR_LIMIT.weight.min)
      .max(VAR_LIMIT.weight.max)
      .required()
      .messages({
        "any.required": `"Berat badan" tidak boleh kosong`,
        "number.max": `"Berat badan" tidak valid`,
        "number.min": `"Berat badan" tidak valid`,
      }),
    height: Joi.number()
      .min(VAR_LIMIT.height.min)
      .max(VAR_LIMIT.height.max)
      .required()
      .messages({
        "any.required": `"Tinggi badan" tidak boleh kosong`,
        "number.max": `"Tinggi badan" tidak valid`,
        "number.min": `"Tinggi badan" tidak valid`,
      }),
  });
  return schema.validate(data);
};
